import { createPriceDtoFromAnalyticPriceModel, PriceModel } from "./price";
import { B2bMarketPriceDto } from "@vini-wine/core-dtos";

export interface B2bMarketPriceModel {
  // default includes
  price: PriceModel | null;

  // transform
  updatedAt: Date;
}

export const createB2BMarketPriceDtoFromAnalyticB2BMarketPriceModel = (
  b2bMarketPrice: B2bMarketPriceModel,
): B2bMarketPriceDto => {
  return {
    price: b2bMarketPrice.price
      ? createPriceDtoFromAnalyticPriceModel(b2bMarketPrice.price)
      : null,
    updatedAt: b2bMarketPrice.updatedAt,
  };
};
